<template>
	<v-dropdown
		class="shared-add-button-dropdown"
		placement="bottom">
		<o-button
			class="shared-add-button"
			color="default"
			prefix-icon="add_plus"
			outline/>

		<template #popper>
			<slot/>
		</template>
	</v-dropdown>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedAddButtonEmits, SharedAddButtonProps } from './SharedAddButtonSetup';
import SharedAddButtonSetup from './SharedAddButtonSetup';
const emits = defineEmits<SharedAddButtonEmits>() as SharedAddButtonEmits;
const props = withDefaults(defineProps<SharedAddButtonProps>(), SharedAddButtonSetup.defaultProps);
const setup = new SharedAddButtonSetup(props, emits);
// #endregion
</script>

<style lang="less" scoped>
@import "@/styles/mixins";

.shared-add-button {
	position: relative;
	overflow: hidden;
	border: 0.06rem dashed var(--grey);
	border-radius: 0.2rem;
	background: transparent;

	&-dropdown {
		width: fit-content;
		height: fit-content;
	}

	:deep(> .orion-button__icon) {
		font-size: 1.5rem;
		color: var(--grey-dark);
	}

	&:hover {
		border: 0.06rem dashed var(--info);
		background-color: rgba(var(--rgb-info), 0.1);

		:deep(> .orion-button__icon) {
			color: var(--info);
		}
	}

	.square(3.4rem);
}
</style>
